<template>
  <section class="content-section animate fadeInLeft">
    <h2 class="animate text-center bigMarginBottom">The Path is…</h2>
    <div class="universal-logos-container">
      <img
        src="@/assets/images/universal_logos.png"
        alt="Universal Logos"
        class="universal-logos"
      />
      <p class="logos-caption animate">
        Visual reference of how the logo may evolve through the twelve
        collections and stories - each archetype awakening in a different phase
        of the brand's unfolding consciousness, revealed progressively in the
        twelve cinematic works.
      </p>
    </div>
    <div class="identity-statements">
      <div class="identity-column">
        <div class="statement animate">
          <h3 class="animate">…a Visionary</h3>
          <p>
            The Path knows there’s more than what meets the eye. Clear vision
            creates her future.
          </p>
        </div>

        <div class="statement animate">
          <h3 class="animate">…a Storyteller</h3>
          <p>
            The Path is loyal to the story and to each story’s demands. The Path
            leads with the imagination that rewrites reality.
          </p>
        </div>

        <div class="statement animate">
          <h3 class="animate">…a Disrupter</h3>
          <p>
            The Path confronts resistance and changes the way something is
            operating by showing the possibility for something different.
          </p>
        </div>

        <div class="statement animate">
          <h3 class="animate">…a Master Magician</h3>
          <p>
            The Path creates something out of nothing and turns lead into pure
            gold.
          </p>
        </div>

        <div class="statement animate">
          <h3 class="animate">…a Soul Forger</h3>
          <p>
            The Path shapes destiny at its root, reforging identity, purpose,
            and reality itself. Through destruction and creation, she carves new
            pathways for consciousness to incarnate.
          </p>
        </div>
      </div>

      <div class="identity-column">
        <div class="statement animate">
          <h3 class="animate">…a Pioneer</h3>
          <p>
            By following her own counsel, The Path does something that was never
            done before. She opens a road to an unforeseen possibility.
          </p>
        </div>

        <div class="statement animate">
          <h3 class="animate">…a Shapeshifter</h3>
          <p>
            The only constant is change. The Path is not afraid to sacrifice
            what no longer works for the sake of authenticity. The Path is open
            to mutation and will evolve as her consciousness does.
          </p>
        </div>

        <div class="statement animate">
          <h3 class="animate">…a Dreamer</h3>
          <p>
            The Path invites people into a world that is on the cutting edge of
            change. A world where fiction grew to become real. A world where
            ideas find their way towards physical manifestation.
          </p>
        </div>

        <div class="statement animate">
          <h3 class="animate">…a Mystic</h3>
          <p>
            Just like particles that change when they know they are being
            observed, The Path offers an immersive experience that requires
            complete trust. In trusting what is coming without the need to know
            exactly what that is – yet surrendering step by step, season by
            season, collection by collection, click by click – we will pierce
            all the pieces of the puzzle together and the truth will make itself
            known.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { onMounted } from "vue";

export default {
  name: "ThePathsIdentity",
  setup() {
    onMounted(() => {
      const elements = document.querySelectorAll(".animate");
      const observerOptions = {
        root: null,
        rootMargin: "-10% 0px",
        threshold: 0,
      };
      const handleIntersection = (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          } else {
            entry.target.classList.remove("active");
          }
        });
      };
      const observer = new IntersectionObserver(
        handleIntersection,
        observerOptions
      );
      elements.forEach((el) => {
        if (el) observer.observe(el);
      });
    });
  },
};
</script>

<style scoped>
.universal-logos-container {
  width: 100%;
  margin: var(--doubleSpace) 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: calc(var(--largeSpace) * 1.5);
}

.universal-logos {
  width: 100%;
  height: auto;
  object-fit: contain;
  border-radius: var(--border-radius-medium);
}

.logos-caption {
  margin-top: var(--largeSpace);
  font-style: italic;
  text-align: center;
  color: var(--grey-dark);
  font-size: var(--smallFontSize);
  max-width: 90%;
}

/* Existing styles */
.content-section {
  margin-bottom: 3rem;
  margin-top: 3rem;
}

/* Two independent columns on desktop, one on mobile */
.identity-statements {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
}

.identity-column {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.statement {
  opacity: 0;
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.statement h3 {
  transform: translateX(-18px);
  font-weight: 220;
}

.statement.active {
  opacity: 1;
  transform: translateX(0);
}

/* Animation Classes */
.fadeInLeft {
  animation: fadeInLeft 1s ease forwards;
}

.fadeInRight {
  animation: fadeInRight 1s ease forwards;
}

@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .identity-statements {
    grid-template-columns: 1fr;
  }
}
</style>
